import { gql } from '@apollo/client';

const DELETE_SCHEDULED_EMAIL = gql`
  mutation deleteScheduledEmail($notificationId: String!) {
    deleteScheduledEmail(notificationId: $notificationId) {
      success
    }
  }
`;

export default DELETE_SCHEDULED_EMAIL;
